/**
 *  Старая интеграция
 */
export class MindboxTracker {

    operationSend(operation, data) {
        if (! window.mindbox) {
            console.error('Not mindbox');
            return;
        }

        window.mindbox("async", {
            operation: operation,
            data: data,

            onSuccess: function () {
                console.info('OK MindboxTracker ' + operation + ': %o', data);
            },
            onError: function (error) {
                console.error('ERROR MindboxTracker: ' + operation + ' ' + error);
            }
        });
    }

    categoryView(category) {
        this.operationSend('CategoryView', {
            "viewProductCategory": {
                "productCategory": {
                    "ids": {
                        beautyShop: category.id,
                    }
                }
            }
        });
    }

    productView(product) {
        this.operationSend('ProductView', {
            viewProduct: {
                price: product.price,
                product: {
                    ids: {
                        beautyShop: product.article,
                    }
                }
            }
        });
    }

    setCart(basketData) {
        this.operationSend('SetCart', basketData);
    }

    setWishList(productsData) {
        this.operationSend('SetWishList', productsData);
    }

    authorization(phone) {
        this.operationSend('Authorization', {
            customer: {
                mobilePhone: phone
            }
        });
    }
}



// WEBPACK FOOTER //
// ./modules/mindbox/mindbox-traker.js